import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Wifi: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m635.49 296.95c-35.03-28.73-74.34-50.88-116.85-65.85-41.37-14.56-84.65-21.95-128.63-21.95s-87.26 7.38-128.63 21.95c-42.51 14.96-81.83 37.12-116.85 65.85l-19.02-23.2c37.74-30.95 80.1-54.82 125.92-70.95 44.58-15.69 91.21-23.65 138.6-23.65s94.01 7.96 138.6 23.65c45.81 16.13 88.18 40 125.92 70.95l-19.02 23.2z' />
    <path d='m557.23 387.33c-47.39-37.52-106.78-58.18-167.23-58.18s-119.84 20.66-167.23 58.18l-18.62-23.52c52.67-41.7 118.67-64.66 185.85-64.66s133.18 22.96 185.85 64.66z' />
    <path d='m479.25 478.18c-53.39-38.83-125.12-38.83-178.51 0l-17.65-24.26c31.27-22.75 68.23-34.77 106.9-34.77s75.63 12.02 106.9 34.77l-17.65 24.26z' />
    <circle cx='390' cy='569.15' r='30' />
  </IconBase>
));

Wifi.displayName = 'Wifi';

export default Wifi;
